(() => {
  const parseActivationTime = (value) => {
    if (!value) return null;
    const normalized = value.trim();
    if (!normalized) return null;
    const timestamp = Date.parse(normalized);
    return Number.isNaN(timestamp) ? null : timestamp;
  };

  const getActiveIndex = (items, fallbackIndex) => {
    const now = Date.now();
    let activeIndex = -1;

    items.forEach((item, index) => {
      const timestamp = parseActivationTime(item.dataset.nanoPreorderActivateAt);
      if (timestamp != null && now >= timestamp) {
        activeIndex = index;
      }
    });

    if (activeIndex >= 0) return activeIndex;
    return Math.min(Math.max(fallbackIndex, 0), Math.max(items.length - 1, 0));
  };

  const scheduleNextActivation = (root, items, update) => {
    const now = Date.now();
    const upcoming = items
      .map((item) => parseActivationTime(item.dataset.nanoPreorderActivateAt))
      .filter((timestamp) => timestamp != null && timestamp > now)
      .sort((a, b) => a - b)[0];

    if (!upcoming) return;
    window.setTimeout(update, Math.min(upcoming - now + 100, 2147483647));
  };

  const initPreorder = (root) => {
    if (root.dataset.nanoPreorderReady === 'true') return;
    root.dataset.nanoPreorderReady = 'true';

    const items = Array.from(root.querySelectorAll('[data-nano-preorder-item]'));
    if (items.length === 0) return;

    const fallbackIndex = Number(root.dataset.nanoPreorderFallbackIndex || 1) - 1;
    const cardsWrap = root.querySelector('.nano-preorder__cards');
    const rail = root.querySelector('.nano-preorder__rail');
    let timerSet = false;

    const setProgressPosition = (activeIndex) => {
      const activeItem = items[activeIndex];
      const activeCard = activeItem && activeItem.querySelector('.nano-preorder__card');
      if (!activeCard || !cardsWrap || !rail) return;

      const isMobile = window.matchMedia('(max-width: 1024px)').matches;
      const railRect = rail.getBoundingClientRect();
      const cardRect = activeCard.getBoundingClientRect();

      const position = isMobile
        ? cardRect.top - railRect.top
        : cardRect.left - railRect.left;
      const thumbCenterOffset = isMobile ? 16 : 16;
      const safePosition = Math.max(position, 0);

      root.style.setProperty('--nano-preorder-progress', `${safePosition}px`);
      root.style.setProperty('--nano-preorder-glow-position', `${safePosition + thumbCenterOffset}px`);
    };

    const update = () => {
      const activeIndex = getActiveIndex(items, fallbackIndex);

      root.dataset.nanoPreorderActiveIndex = String(activeIndex + 1);

      items.forEach((item, index) => {
        item.classList.toggle('is-active', index === activeIndex);
      });

      window.requestAnimationFrame(() => setProgressPosition(activeIndex));

      if (!timerSet) {
        timerSet = true;
        scheduleNextActivation(root, items, () => {
          timerSet = false;
          update();
        });
      }
    };

    update();

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(update, 120);
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-nano-preorder]').forEach(initPreorder);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
